<!--  -->
<template>
  <div style="padding: 20px;">
    <div>
      <el-input v-model="parmrs.material_id" style="width: 300px;" placeholder="素材ID" />
      <el-input v-model="parmrs.material_name" style="width: 300px;margin-left: 20px;" placeholder="素材名称" />
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        style="width: 300px;margin-left: 20px;"
        @change="handleDateChange"
      />
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 20px;"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
    </div>
    <div>
      <!-- 汇总信息栏 -->
      <!-- <el-card shadow="never" class="summary-card">
        <div class="summary-container">
          <div class="summary-item">
            <div class="summary-label">利润</div>
            <div class="summary-value">{{ reportData.profit || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">扣点利润</div>
            <div class="summary-value">{{ reportData.rebate_profit || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">总消耗</div>
            <div class="summary-value">{{ reportData.total_cost || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">总回收</div>
            <div class="summary-value">{{ reportData.total_income || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">总回收扣点</div>
            <div class="summary-value">{{ reportData.total_rebate_income || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">总回收roi</div>
            <div class="summary-value">{{ reportData.total_rebate_roi || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">总ROI</div>
            <div class="summary-value">{{ reportData.total_roi || 0 }}</div>
          </div>
        </div>
      </el-card> -->
      <!-- Element UI 表格 -->
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%;margin-top: 20px;"
      >
        <el-table-column prop="material_name" label="素材名称" width="300" align="center" />
        <el-table-column prop="material_id" label="素材ID" width="300" align="center" />
        <el-table-column prop="total_cost" label="总消耗" align="center" />
      </el-table>
      <pagination-right
        :current-page="parmrs.page"
        :page-sizes="[10]"
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import { iaaMaterialReportdepartmentlistNative, iaapitcherindexNative, reportcostListNative } from '@/api/TKreleaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      options: [],
      optionstwo: [],
      parmrs: {
        page: 1,
        page_size: 10,
        start_time: '',
        end_time: '',
        material_id: '',
        material_name: ''
      },
      dateRange: [],
      tableData: [],
      total: null,
      reportData: {}
    }
  },
  created() {
    // this.list()
    this.getlist()
  },
  mounted() {

  },
  methods: {
    list() {
      iaaMaterialReportdepartmentlistNative({ page: 1, page_size: 100 }).then((res) => {
        this.options = res.data.list
      })
    },
    newqwr() {
      iaapitcherindexNative({ page: 1, page_size: 100, department_id: this.parmrs.department_id }).then((res) => {
        this.optionstwo = []
        this.optionstwo = res.data.list
      })
    },
    handleDateChange(val) {
      if (val && val.length === 2) {
        this.parmrs.start_time = val[0]
        this.parmrs.end_time = val[1]
      } else {
        this.parmrs.start_time = ''
        this.parmrs.end_time = ''
      }
      console.log('开始时间:', this.start_time, '结束时间:', this.end_time)
    },
    search() {
      this.parmrs.page = 1
      this.getlist()
    },
    reset() {
      this.parmrs = {
        page: 1,
        page_size: 10,
        start_time: '',
        end_time: '',
        material_id: '',
        material_name: ''
      }
      this.dateRange = []
      this.getlist()
    },
    getlist() {
      reportcostListNative(this.parmrs).then((res) => {
        console.log(res)
        this.reportData = res.data
        this.tableData = res.data.list
        this.total = res.data.count
      })
    },
    // 分页
    fetchPageSize(e) {
      this.parmrs.page_size = e
      this.getlist()
    },
    fetchCurrentPage(e) {
      this.parmrs.page = e
      this.getlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
/* @import url(); 引入css类 */
.summary-card {
  background-color: #f9fafc;
  margin-bottom: 10px;
  margin-top: 20px;
}
.summary-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.summary-item {
  flex: 1;
  min-width: 120px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  padding: 10px 15px;
  text-align: center;
}
.summary-label {
  font-size: 13px;
  color: #909399;
}
.summary-value {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin-top: 10px;
}
</style>
